import React, { Dispatch, SetStateAction, createContext, useState } from 'react'
import api from '../services/api'

type AddressProps = {
  id: string
  id_responsible_base: string
  address: string
  state: string
  city: string
  burgh: string
  zipcode: string
  latitude: number
  longitude: number
}

type VehicleProps = {
  id: string
  vehicle: string
  color: string
  plate: string
  type: string
}

type LinkedUserProps = {
  id: string
  login: string
  password: string
  role: string
  active: boolean
  is_first: boolean
  created_at: string
  updated_at: string
  id_location: null
}

type UserInfoProps = {
  id_base: string
  name: string
  email: string
  phone: string
  birthdate: string
}

type ContractProps = {
  id: string
}

type ResidentsProps = {
  id: string
  active: boolean
  login: string
  name: string
  email: string
  phone: string
  // base: string
  // outpost: string
  Contract: ContractProps
  Address: AddressProps[]
  Vehicle: VehicleProps[]
  LinkedUsers: LinkedUserProps[]
}

type CreateUserProps = {
  id: string
  login: string
  password: string
  role: string
  base: string
  outpost: string
  Contract: ContractProps
  UserInfo: UserInfoProps
  Address: AddressProps[]
  Vehicle: VehicleProps[]
}

type ContextProps = {
  editItem: ResidentsProps | null
  setEditItem: Dispatch<SetStateAction<ResidentsProps | null>> | undefined
  startEditing: (item: ResidentsProps) => void
  stopEditing: () => void
  updateItem: (updatedItem: ResidentsProps) => void
  createItem: (createdItem: CreateUserProps) => void
  createResident: () => void
  sendUpdate: () => void
  activateUser: () => void
  disableUser: () => void
  errorModal: boolean
  errorMessage: string
  modalSaveNewResidentSuccess: boolean
  setModalSaveNewResidentSuccess: (boolean) => void
  setErrorModal: (boolean) => void
  setRegistered: (boolean) => void
}

export const ContextResidents = createContext<ContextProps | undefined>(
  undefined,
)

const ContextResidentsProvider = (props) => {
  const [editItem, setEditItem] = useState<ResidentsProps | null>(null)
  const [createUser, setCreateUser] = useState<CreateUserProps | null>(null)

  const [modalSaveNewResidentSuccess, setModalSaveNewResidentSuccess] =
    useState(false)
  const [modalSaveNewResident, setModalSaveNewResident] = useState(false)
  useState(false)

  const [errorModal, setErrorModal] = useState<boolean>(false)
  const [registered, setRegistered] = useState<boolean>(false)

  const [errorMessage, setErrorMessage] = useState<string>('')

  // const [formData, setFormData] = useState<ResidentsProps>({
  //   id: editItem?.id,
  //   active: true,
  //   name: '',
  //   email: '',
  //   phone: '',
  //   base: '',
  //   outpost: '',
  //   Address: [
  //     {
  //       id: '',
  //       address: '',
  //       state: '',
  //       city: '',
  //       burgh: '',
  //       zipcode: '',
  //       latitude: 0,
  //       longitude: 0,
  //     },
  //   ],
  //   Vehicles: [
  //     {
  //       id: '',
  //       vehicle: '',
  //       color: '',
  //       plate: '',
  //       type: '',
  //     },
  //   ],
  //   LinkedUsers: [
  //     {
  //       id: '',
  //       login: '',
  //       password: '',
  //       role: '',
  //       active: true,
  //       is_first: false,
  //       created_at: '',
  //       updated_at: '',
  //       id_location: null,
  //     },
  //   ],
  // })

  const activateUser = () => {
    api
      .put('/v1/dashboard/residents/update', { id: editItem?.id, active: true })
      .then((res) => {
        console.log(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const disableUser = () => {
    api
      .delete('/v1/user/delete', {
        data: {
          id: editItem?.id,
        },
      })
      .then((res) => {
        console.log('DELETE MORADOR =>  ', res.data)
        setEditItem(null)
        setCreateUser(null)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const startEditing = (item: ResidentsProps) => {
    setEditItem(item)
  }

  const stopEditing = () => {
    // setEditItem(null)
    // setCreateUser(null)
  }

  const updateItem = (updatedItem: ResidentsProps) => {
    setEditItem(updatedItem)
  }

  const sendUpdate = () => {
    console.log(editItem, 'AQUI O MALANDRO')
    try {
      if (editItem != null && editItem) {
        const newFormData = new FormData()
        // console.log(editItem, 'AQUI O MALANDRO')

        // ESTA MERDA POR ALGUM MOTIVO N TA MUDANDO OS DADOS DO USUARIO
        const UserInfo = {
          name: editItem.name,
          email: editItem.email,
          phone: editItem.phone.replace(/\D/g, ''),
        }

        newFormData.append('id', editItem.id)
        newFormData.append('login', editItem.login)
        // newFormData.append('outpost', editItem.outpost)
        newFormData.append('active', editItem.active ? 'true' : 'false')
        newFormData.append('UserInfo', JSON.stringify(UserInfo))

        newFormData.append('Address', JSON.stringify(editItem.Address))
        newFormData.append('Vehicle', JSON.stringify(editItem.Vehicle))
        newFormData.append('Contract', JSON.stringify(editItem.Contract))

        api
          .put('/v1/dashboard/residents/update', newFormData)
          .then((res) => {
            console.log('AAAAAHFLK', res.data)
            // setEditItem(null)
            // setCreateUser(null)
          })
          .catch((err) => {
            console.log(err.data)
          })
      }
    } catch (error) {
      console.log(error)
      console.log(error.message)
    }
  }

  const createItem = (createdItem: CreateUserProps) => {
    setCreateUser(createdItem)
  }

  const createResident = () => {
    try {
      if (createUser != null && createUser) {
        const newFormData = new FormData()
        newFormData.append('id', createUser.id)
        newFormData.append('login', createUser.login)
        newFormData.append('password', createUser.password)
        newFormData.append('role', 'MORADOR_ADM')
        // newFormData.append('outpost', createUser.outpost)
        // newFormData.append('base', createUser.base)
        newFormData.append('UserInfo', JSON.stringify(createUser.UserInfo))
        newFormData.append('Address', JSON.stringify(createUser.Address))
        newFormData.append('Vehicle', JSON.stringify(createUser.Vehicle))
        newFormData.append('Contract', JSON.stringify(createUser.Contract))
        // for (const key of newFormData.entries()) {
        //   console.log(key[0] + ', ' + key[1], 'FFFFF')
        // }

        // for (const key in createUser) {
        //   console.log(key, createUser[key])
        //   newFormData.append(key, createUser[key])
        // }

        api
          .post('/v1/dashboard/residents/create', newFormData)
          .then(() => {
            setEditItem(null)
            setCreateUser(null)
            setModalSaveNewResidentSuccess(true)
          })
          .catch((err) => {
            console.log('🚀 ~ createResident ~ err:', err)
            const errors = {
              'User with this login already exists':
                'O login escolhido já está em uso. Por favor, escolha um login diferente.',
              'User with this email already exists':
                'O email escolhido já está em uso. Por favor, escolha um email diferente.',
              'User with this phone already exists':
                'O telefone escolhido já está em uso. Por favor, escolha um telefone diferente.',
            }
            if (errors[err.response.data]) {
              setErrorModal(true)
              setModalSaveNewResidentSuccess(false)
              setErrorMessage(errors[err.response.data])
            }
          })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const contextValue: ContextProps = {
    editItem,
    setEditItem,
    startEditing,
    stopEditing,
    updateItem,
    sendUpdate,
    createItem,
    createResident,
    activateUser,
    disableUser,
    setErrorModal,
    setRegistered,
    errorMessage,
    errorModal,
    modalSaveNewResidentSuccess,
    setModalSaveNewResidentSuccess,
  }

  return (
    <ContextResidents.Provider value={contextValue}>
      {props.children}
    </ContextResidents.Provider>
  )
}

export default ContextResidentsProvider
